// Import Swiper core and required modules
import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules'; // ✅ Import Mousewheel properly

import "swiper/css"; // Core Swiper styles
import "swiper/css/pagination"; // Pagination styles

// Extend global window object to store Swiper
declare global {
  interface Window {
    Swiper: typeof Swiper;
    Mousewheel: typeof Mousewheel; // ✅ Store Mousewheel in the global object
  }
}

// Store Swiper and Mousewheel in the global `window` object
window.Swiper = Swiper;
window.Mousewheel = Mousewheel; // ✅ Now Mousewheel is available globally
